import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from '../../../models/allpayments'; // Importing allpayments model
import { devConfig, countries } from '../../../config/config'; // Importing configuration settings

/**
 * Class representing the table translation manager view.
 * @extends JetView
 */
export default class tableTranslationManagerView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    view: 'search', // Search input for filtering translations
                    align: 'center',
                    placeholder: 'Buscar From Name', // Placeholder text
                    id: 'search', // Unique identifier for the search input
                },
                {
                    id: 'preloader', // Preloader ID for loading state
                    cols: [
                        {
                            view: 'datatable', // Data table for displaying translations
                            id: 'datatable', // Unique identifier for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                {
                                    id: 'rating', // Column for edit icon
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    template: function (obj) {
                                        // Template function to display edit icon based on permissions
                                        if (devConfig.getPermAction('translationManagerEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon
                                        } else {
                                            return ''; // No icon if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column for translation ID
                                    header: 'Id',
                                    width: 70,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'LangTo', // Column for target language
                                    header: _('Lang To'), // Localized header
                                    width: 50,
                                    sort: 'int',
                                },
                                {
                                    id: 'Text', // Column for source text
                                    header: _('From Name'), // Localized header
                                    width: 300,
                                    sort: 'int',
                                },
                                {
                                    id: 'ToText', // Column for translated text
                                    header: 'To Name',
                                    width: 300,
                                    sort: 'int',
                                    editor: 'text', // Editable field
                                    align: 'right',
                                },
                                {
                                    id: 'ModifiedLocal', // Column for last modified timestamp
                                    header: _('Modificado'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            editable: true, // Enable editing of the data table
                            on: {
                                /**
                                 * Event triggered after editing a cell.
                                 * @param {Object} euv - Event object.
                                 * @param {String} id - ID of the edited row.
                                 * @param {Object} grid - Reference to the data table.
                                 */
                                onAfterEditStop: function (euv, id, grid) {
                                    var filter = ''; // Filter variable
                                    grid = $$('datatable'); // Reference to the data table
                                    var url = grid.data.url; // URL for data fetching
                                    var values = this.getItem(id.row); // Get edited row values
                                    if (values.ToText != '') {
                                        // Check if translated text is not empty
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for AJAX request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Reference/SaveTranslationEntries', // API endpoint for saving translations
                                                '[{"LanguageId":"' +
                                                    values.LangTo +
                                                    '","Text":"' +
                                                    values.ToText +
                                                    '","TranslationId":"' +
                                                    values.Id +
                                                    '"}]', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response JSON
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Title for error message
                                                                ),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Ocurrio un error, comuniquese con soporte', // Error message
                                                                ),
                                                            });
                                                        } else {
                                                            webix.message(
                                                                _(
                                                                    'Traducción Agregada', // Success message
                                                                ),
                                                            );
                                                            values.ModifiedLocal = moment().format(); // Update modified timestamp
                                                        }
                                                    },
                                                },
                                            );
                                    }
                                    console.log('EDITADO!'); // Log edit action
                                },
                            },
                            onClick: {
                                /**
                                 * Event triggered on clicking the edit icon.
                                 * @param {Object} euv - Event object.
                                 * @param {String} id - ID of the clicked row.
                                 */
                                edit: function (euv, id) {
                                    $$('editTranslation').show(); // Show edit translation popup
                                },
                            },
                            math: true, // Enable math operations in the data table
                            loadahead: devConfig.getDefaultDataFetch(), // Preload data configuration
                            pager: 'pagerA', // Pager ID for pagination
                            url: devConfig.geturlApi() + 'Reference/GetTranslations', // API endpoint for fetching translations
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and binds events.
     * @param {Object} grid - Reference to the data table.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the data table
        var url = grid.data.url; // URL for data fetching
        var filter = ''; // Filter variable
        var popup = webix.ui({
            view: 'window', // Popup window for editing translations
            id: 'editTranslation', // Unique identifier for the popup
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Editar Traducción') }, // Label for the popup
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'form', // Form inside the popup
                id: 'editform', // Unique identifier for the form
                elements: [
                    { view: 'text', label: 'Id', name: 'Id', readonly: true }, // Read-only field for ID
                    { view: 'text', label: _('To Name'), name: 'ToText' }, // Editable field for translated text
                    {
                        cols: [
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on click
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('editform').getValues(); // Get form values
                                    if (values.ToText != '') {
                                        // Check if translated text is not empty
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for AJAX request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Reference/SaveTranslationEntries', // API endpoint for saving translations
                                                '[{"LanguageId":"' +
                                                    values.LangTo +
                                                    '","Text":"' +
                                                    values.ToText +
                                                    '","TranslationId":"' +
                                                    values.Id +
                                                    '"}]', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            _('Error! '), // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response JSON
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Title for error message
                                                                ),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Ocurrio un error, comuniquese con soporte', // Error message
                                                                ),
                                                            });
                                                        } else {
                                                            webix.message(
                                                                _(
                                                                    'Traducción Editada', // Success message
                                                                ),
                                                            );
                                                            values.ModifiedLocal = moment().format(); // Update modified timestamp
                                                        }
                                                    },
                                                },
                                            );
                                    }
                                    this.getTopParentView().hide(); // Hide the popup after saving
                                },
                            },
                        ],
                    },
                ],
            },
        });
        var popupAdd = webix.ui({
            view: 'window', // Popup window for adding translations
            width: 450, // Width of the popup
            id: 'AddProducts', // Unique identifier for the popup
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Añadir Traducción') }, // Label for the popup
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'form', // Form inside the popup
                id: 'addform', // Unique identifier for the form
                elements: [
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text', // Input field for name
                                labelPosition: 'top',
                                label: _('Name'),
                                name: 'Name',
                            },
                            {
                                view: 'combo', // Combo box for activation status
                                labelPosition: 'top',
                                label: _('Estado'),
                                name: 'IsActivate',
                                options: [
                                    { id: 'A', value: _('Activado') }, // Activated option
                                    { id: 'I', value: _('Inactivado') }, // Inactivated option
                                ],
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on click
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button', // Add button
                                type: 'form',
                                value: _('Añadir'),
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for AJAX request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Translation/SaveTranslation', // API endpoint for saving translations
                                            '{"Name":"' + values.Name + '","IsActivate":"' + values.IsActivate + '"}', // JSON payload
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Traducción Agregada'), // Success message
                                                    );
                                                    grid.clearAll(); // Clear the data table
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload data with pagination
                                                    );
                                                },
                                            },
                                        );
                                    this.getTopParentView().hide(); // Hide the popup after adding
                                },
                            },
                        ],
                    },
                ],
            },
        });
        this.on(this.app, 'addMessage:button', (filter) => {
            popupAdd.show(); // Show add translation popup
        });
        this.on(this.app, 'translation:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filtering
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the data table
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Reload data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Reload data after sorting
            );
        });
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player
            );
        });
        $$('search').attachEvent('onTimedKeyPress', function () {
            var value = this.getValue().toLowerCase(); // Get search input value
            $$('datatable').filter(function (obj) {
                return obj.Name.toLowerCase().indexOf(value) != -1; // Filter data table based on search input
            });
        });
        $$('editform').bind($$('datatable')); // Bind edit form to data table
    }
}

// FILE DOCUMENTED
